import axios from 'axios'

class RootService {
  constructor (config) {
    // eslint-disable-next-line camelcase
    const { api_url, token } = config
    this.api = axios.create({
      // eslint-disable-next-line camelcase
      baseURL: `${api_url}/`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
    )
  }
}

export default RootService
